import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative"
    },
    exit: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 3,
      color: "#000",
      fontWeight: "700"
    },
    roundabout: {
      position: "absolute",
      width: "76px",
      height: "76px",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    }
  })
);

export default function InstructionIcon(props) {
  const { className, type, modifier, exit, isRoundabout } = props;
  const { classes } = useStyles();

  if (isRoundabout && typeof exit === "number") {
    return (
      <div className={className}>
        <img src="/assets/icons/directions/roundabout.svg" className={classes.roundabout} />
        <Typography className={classes.exit} variant="body1">{exit}</Typography>
      </div>
    );
  }

  const url = `/assets/icons/directions/${type?.replaceAll(" ", "_") || "continue"}${!!modifier ? `_${modifier.replaceAll(" ", "_")}` : ""}.svg`;

  return (
    <img src={url} className={className} />
  );
}

